<template>
    <div>
        <router-link :to="this.to" class="router">
            <button @click="clicked()" :class="this.type" :style="customStyles" :disabled="loading || disabled">
                <div class="wrapper">
                    <span v-if="typeof icon !== 'undefined' && icon !== ''" :class="['icon', icon]"></span>
                    <span>{{ title }}</span>
                    <div v-if="loading" class="loaderContainer" :style="{width: loaderSize}">
                        <svg class="spinner" viewBox="0 0 50 50"
                             :style="{width: loaderSize, height:loaderSize, margin: margin}">
                            <circle class="path" cx="25" cy="25" r="20" fill="none" stroke-width="5"></circle>
                        </svg>
                    </div>
                </div>
            </button>
        </router-link>
    </div>
</template>

<script>
export default {
    name: "AdaButton",
    props: {
        title: {
            type: String,
            required: true
        },
        to: {
            type: String,
            required: false,
            default: ''
        },
        type: {
            type: [String, Array],
            required: true,
            default: 'button'
        },
        icon: {
            type: String,
            required: false
        },
        customStyles: {
            type: [String, Object],
            required: false
        },
        loading: {
            type: Boolean,
            default: false
        },
        loaderSize: {
            type: String,
            default: '20px'
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        margin() {
            let size = parseInt(this.loaderSize) / 2;
            return `-${size} 0 0 -${size}`
        }
    },
    methods: {
        clicked: function () {
            this.$emit('click');
        },
        getImgUrl: function (pic) {
            return require('../../assets/' + pic)
        }
    }
}
</script>

<style lang="scss" scoped>
a {
    text-decoration: none;
}

button {
    font-size: 14px;
    padding: 0.3em;
    min-width: 10em;
    cursor: pointer;
    display: flex;
    align-items: center;
    width: 100%;
    height: 100%;
    position: relative;
    transition: width, margin 0.3s ease-in-out;
}

button:focus {
    outline: 0;
}

.wrapper {
    height: 100%;
    display: flex;
    align-items: center;
    text-align: center;
    margin: auto;
}

.router span {
    color: #fff;
    display: flex;
    height: 100%;
    align-items: center;
    line-height: 1;
    -moz-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
    -o-user-select: none;
}

.icon {
    margin-right: .5em;
}

.createButton {
    background-color: $pink;
    border-color: $pink;
    border-radius: 5px;
    border-style: solid;
    text-transform: uppercase;
    padding: .5em .7em .5em .7em;
    font-size: 13px;
    transition: all 0.3s ease-in;
}

button:disabled {
    background-color: $grey;
    border-color: $grey;
    cursor: not-allowed;
}

.noBorder {
    border-radius: 0;
}

.large {
    padding: 10px 10px;
    font-size: 13px;
    font-weight: 500;

    .icon {
        font-size: 18px;
    }
}

.grey {
    background-color: $darkGrey;
    border-color: $darkGrey;
}

.fullWidthButton {
    color: $pink;
    width: 100%;
    background-color: #fff;
    border: none;
    padding: 1em;

    .icon {
        font-size: 1.3rem !important;
    }

    span {
        color: inherit;
        font-size: 0.9rem;
        font-weight: bolder;
    }

    &:hover {
        color: #fff;
        background-color: $pink;
    }

    &.tracking {
        background-color: $oddTableRow;
        padding: 0.7em 1em;
        border-top: 1px solid $lightGrey;

        &:hover {
            color: $pink;
            background-color: #fff;
        }
    }
}

.dialogConfirm, .dialogCancel {
    font-weight: 500;
    border-radius: 6px;
    text-transform: uppercase;
    padding: 5px 20px;
    font-size: 13px;
    border: 1px solid transparent;
}

.dialogConfirm {
    background: $pink;

}

.dialogCancel {
    background: $darkGrey;
}

.dialogConfirm .icon {
    font-size: 0.9rem;
}

.dialogCancel .icon {
    font-size: 1.2rem;
}

.blue {
    background: $blue;
    border-color: $blue;
    border-radius: 4px;
    border: none;
}

.grey {
    background: $darkGrey;
    border-color: $darkGrey;
}

.outlined {
    background: transparent;
    border: 1px solid $darkGrey;
    border-radius: 5px;
    padding: 8px 10px;
    font-weight: bold;
    font-size: 13px;
    min-width: auto;

    &.noPadding {
        padding: 0px 3px;
    }

    span {
        color: $darkGrey;

        &.icon-visible {
            font-size: 24px;
            margin-right: 0;
        }
    }
}

.loaderContainer {
    margin-left: 10px;
    position: relative;

    .spinner {
        animation: rotate 2s linear infinite;
        z-index: 2;
        position: absolute;

        top: 50%;
        left: 50%;


        & .path {
            stroke: #fff;
            stroke-linecap: round;
            animation: dash 1.5s ease-in-out infinite;
        }

    }
}

@keyframes rotate {
    100% {
        transform: rotate(360deg);
    }
}

@keyframes dash {
    0% {
        stroke-dasharray: 1, 150;
        stroke-dashoffset: 0;
    }
    50% {
        stroke-dasharray: 90, 150;
        stroke-dashoffset: -35;
    }
    100% {
        stroke-dasharray: 90, 150;
        stroke-dashoffset: -124;
    }
}

</style>